module.exports = __webpack_public_path__ + "static/img/2-11.9857943.png";


//////////////////
// WEBPACK FOOTER
// ./static/feige/6/2-11.png
// module id = 262
// module chunks = 0